import React, { useEffect } from 'react';
import axios from 'axios';
import { plato_api_image_models_path } from '@/modules/routes';
import { useQuery } from '@tanstack/react-query';
import { IImageModel } from '../SlideShow/stores/useSlideShowStore';
import { useSlideShowIds } from './SectionEditorUtils';
import { getSlideShowImageQuery } from '../SlideShow/Utils/useSlideShowImageFetcher';

interface ImageQueryFetcherProps {
  ids: number[];
  sectionId: number | string;
  setLessonImages: React.Dispatch<React.SetStateAction<{ [key: number]: IImageModel[] }>>;
}
const ImageQueryFetcher = ({ ids, sectionId, setLessonImages }: ImageQueryFetcherProps) => {
  const sectionParams = { for_model: { model_id: sectionId, model_type: 'Section' } };
  const { isSuccess, data: sectionImageModels } = useQuery({
    queryFn: async () => {
      const res = await axios.get(plato_api_image_models_path(sectionParams));
      return res.data.data;
    },
    queryKey: ['getLessonImages', sectionId],
  });

  const slideShowImageQueries = ids.map(id => getSlideShowImageQuery(id));
  useEffect(() => {
    slideShowImageQueries.forEach(async (query) => {
      const queryData = await query();

      setLessonImages((prev) => {
        const { length } = Object.keys(prev);
        return { ...prev, [length]: queryData };
      });
    });
  }, []);

  useEffect(() => {
    if (isSuccess && sectionImageModels) {
      setLessonImages((prev) => {
        const { length } = Object.keys(prev);
        return { ...prev, [length]: sectionImageModels };
      });
    }
  }, [sectionImageModels]);

  return null;
};

type ImageFetcherProps = { lessonId: number | string, sectionId: number | string }
& Omit<ImageQueryFetcherProps, 'ids'>;

const ImageFetcher = ({ lessonId, sectionId, setLessonImages }: ImageFetcherProps) => {
  const { data } = useSlideShowIds(lessonId);

  if (data.length === 0) return null;

  return (
    <ImageQueryFetcher
      ids={data.map(({ id }) => id)}
      sectionId={sectionId}
      setLessonImages={setLessonImages}
    />
  );
};

export default ImageFetcher;
